// extracted by mini-css-extract-plugin
module.exports = {"emojiPopover":"style_emojiPopover__17Ehu"};